import { every, some } from 'lodash'

import { RenderRule } from 'common/interfaces'
import { conditionsMap } from 'utils/conditions'
import { MustacheCustomRender } from 'utils/hook'
import { CheckFunction } from 'utils/interfaces'

export const renderRule = (rules: RenderRule[], render: MustacheCustomRender): boolean =>
  some(rules, (el) =>
    every(Object.entries(el.rules), ([fieldName, rules]) =>
      every(Object.entries(rules), ([rule, value]) => {
        const checkFunction = conditionsMap[rule as CheckFunction]
        if (render(fieldName) === undefined) {
          return false
        }

        // @ts-expect-error Type error
        return checkFunction(render(fieldName), value)
      })
    )
  )
